// src/store/memberStore.js
import { create } from "zustand";
import { toast } from "react-toastify";
import axiosToken from "../api/axiosClient";
import userManagementStore from "./userManagementStore";

export const useMemberStore = create((set, get) => ({
    // États
    roles: [],
    isLoadingRoles: false,

    members: [],
    isLoadingMembers: false,
    isLoadingMember: false,
    roleMemberName: "",
    roleMember: [],
    isLoadingRoleMember: false,


    employees: [],
    isLoadingEmployees: false,

    admins: [],
    isLoadingAdmins: false,

    actionLoading: false,

    // ==================== RÉCUPÉRATION DES DONNÉES ====================
    syncEmployeeStatusChange: (employeId, newStatus) => {
        set(state => ({
            employees: state.employees.map((employe) => {
                if (employe.id === employeId) {
                    return {
                        ...employe,
                        is_active: newStatus
                    };
                }
                return employe;
            })
        }));
    },
    syncAddNewEmploye: (newEmploye) => {
        set(state => ({
            employees: [...state.employees, newEmploye]
        }));
    },

    // Récupérer tous les employés
    getEmployees: async () => {
        set({ isLoadingEmployees: true });
        try {
            const response = await axiosToken.get('/user/all/employee');
            set({
                employees: response.data.data.users || response.data,
                isLoadingEmployees: false
            });
            return response.data.data.users || response.data;
        } catch (error) {
            console.error("Erreur getEmployees :", error);
            toast.error(error?.response?.data?.error || "Erreur lors du chargement des employés.");
            set({ isLoadingEmployees: false });
            return [];
        }
    },

    syncMemberStatusChange: (memberId, newStatus) => {
        set(state => ({
            members: state.members.map((member) => {
                if (member.id === memberId) {
                    return {
                        ...member,
                        is_active: newStatus
                    };
                }
                return member;
            })
        }));
    },
    syncAddNewMember: (newMember) => {
        set(state => ({
            members: [...state.members, newMember]
        }));
    },

    // Récupérer tous les members
    getMembers: async () => {
        set({ isLoadingMembers: true });
        try {
            const response = await axiosToken.get('/user/all/admin');
            set({
                members: response.data.data.users || response.data,
                isLoadingMembers: false
            });
            return response.data.data.users || response.data;
        } catch (error) {
            console.error("Erreur getMembers :", error);
            toast.error(error?.response?.data?.error || "Erreur lors du chargement des membres.");
            set({ isLoadingMembers: false });
            return [];
        }
    },


    // Récupérer un utilisateur par ID
    getMemberById: async (userId) => {
        set({ isLoadingMember: true });
        try {
            const response = await axiosToken.get(`/user/${userId}`);
            const member = response.data.data || response.data;
            set({ isLoadingMember: false });
            return member;
        } catch (error) {
            console.error("Erreur getMemberById :", error);
            toast.error(error?.response?.data?.error || "Erreur lors du chargement de l'utilisateur.");
            set({ isLoadingMember: false });
            return null;
        }
    },

    // Récupérer un utilisateur par ID de rôle
    getMemberByRole: async (roleId) => {
        set({ isLoadingRoleMember: true });
        try {
            if (get().members.length === 0) {
                await get().getMembers();
            }

            const filteredMembers = (get().members).filter((member) => member.role.id == roleId)
            set({ roleMember: filteredMembers, isLoadingRoleMember: false });
            return filteredMembers;
        } catch (error) {
            console.error("Erreur getMemberByRole :", error);
            toast.error("Erreur lors du chargement des membres par rôle.");
            set({ isLoadingRoleMember: false });
            return null;
        }
    },

    getRoleMemberName: async (idRoleMember) => {
        set({ isLoadingRoleMemberName: true });
        try {
            // S'assurer que les rôles sont chargés
            if (get().roles.length === 0) {
                await get().getRoles();
            }

            const role = get().roles.find((role) => role.id == idRoleMember);


            const roleName = role?.name || null;

            set({
                roleMemberName: roleName,
                isLoadingRoleMemberName: false
            });

            return roleName;
        } catch (error) {
            console.error("Erreur getRoleMemberName :", error);
            toast.error(error?.response?.data?.error || "Erreur lors du chargement du nom du rôle.");
            set({ isLoadingRoleMemberName: false });
            return null;
        }
    },

    // Récupérer tous les rôles
    getRoles: async () => {
        set({ isLoadingRoles: true });
        try {
            const response = await axiosToken.get('/role');
            const rolesData = response.data.data || response.data;

            set({
                roles: rolesData,
                isLoadingRoles: false
            });

            return rolesData;
        } catch (error) {
            console.error("Erreur getRoles :", error);
            toast.error(error?.response?.data?.error || "Erreur lors du chargement des rôles.");
            set({ isLoadingRoles: false });
            return [];
        }
    },


    // ==================== ACTIONS SUR LES MEMBRES ====================

    // Liste des réservations assignées à un employé.
    isLoadingReservationsEmployee: false,
    reservationsEmployee: [],
    getAvailableEmployee: async (employeeId) => {
        set({ isLoadingReservationsEmployee: true });
        try {
            const response = await axiosToken.get(`reservation/assignement/employee/${employeeId}`);
            const employeeReservationsData = response.data.data || response.data;

            set({
                reservationsEmployee: employeeReservationsData,
                isLoadingReservationsEmployee: false
            });

            return employeeReservationsData;
        } catch (error) {
            console.error("Erreur getRoles :", error);
            toast.error(error?.response?.data?.error || "Erreur lors du chargement des employés disponibles pour cette date.");
            set({ isLoadingReservationsEmployee: false });
            return [];
        }
    },

    // les employés disponibles pour une date
    isLoadingAvailableEmployee: false,
    availableEmployee: [],
    getAvailableEmployee: async (date) => {
        set({ isLoadingAvailableEmployee: true });
        try {
            const response = await axiosToken.get(`user/avalable/employee?date=${date}`);
            const employeeData = response.data.data || response.data;

            set({
                availableEmployee: employeeData,
                isLoadingAvailableEmployee: false
            });

            return employeeData;
        } catch (error) {
            console.error("Erreur getRoles :", error);
            toast.error(error?.response?.data?.error || "Erreur lors du chargement des employés disponibles pour cette date.");
            set({ isLoadingAvailableEmployee: false });
            return [];
        }
    },

    assignLoading: false,
    // Assigner des employés à un rendez-vous
    assignServiceToEmployee: async (idSelectedRdv, employeeIds) => {
        set({ assignLoading: true });
        try {
            const data = {
                employeeIds: employeeIds
            }
            console.log({ data })
            const response = await axiosToken.post(`reservation/assignement/${idSelectedRdv}/assign`, data);

            set({ assignLoading: false });

            const managementStore = userManagementStore.getState();
            managementStore.getAllReservations();
            managementStore.setTemporaryReservation(idSelectedRdv)
            toast.success(`Employé(s) assigné(s) avec succès`);
            return response.data;
        } catch (error) {
            console.error("Erreur lors de l'assignation d'employé à un rendez-vous. Erreur: ", error)
            toast.error(error?.response?.data?.error || "Erreur lors de l'assignation d'employé à un rendez-vous.");
        }
        set({ assignLoading: false });
    },

    reassignLoading: false,
    // Reassigner des employés à un rendez-vous
    reassignServiceToEmployee: async (idAssign, newEmployeeIds, idSelectedRdv) => {
        set({ reassignLoading: true });
        try {
            const data = {
                newEmployeeId: newEmployeeIds[0]
            }

            const response = await axiosToken.put(`reservation/assignement/${idAssign}/reassign`, data);

            set({ reassignLoading: false });

            const managementStore = userManagementStore.getState();
            managementStore.getAllReservations();
            managementStore.setTemporaryReservation(idSelectedRdv)

            toast.success(`Employé(s) réassigné(s) avec succès`);
            return response.data;
        } catch (error) {
            console.error("Erreur lors de la réassignation d'employé à un rendez-vous. Erreur: ", error)
            toast.error(error?.response?.data?.error || "Erreur lors de la réassignation d'employé à un rendez-vous.");
        }
        set({ reassignLoading: false });
    },

    cancelAssignLoading: false,
    // Annuler assignement des employés à un rendez-vous
    cancelAssignServiceToEmployee: async (idAssign, idSelectedRdv) => {
        set({ cancelAssignLoading: true });
        try {
            const response = await axiosToken.delete(`reservation/assignement/${idAssign}/`);

            set({ cancelAssignLoading: false });

            const managementStore = userManagementStore.getState();
            managementStore.getAllReservations();
            managementStore.setTemporaryReservation(idSelectedRdv)

            toast.success(`Assignation supprimé avec succès`);
            return response.data;
        } catch (error) {
            console.error("Erreur lors de l'annulation de l'assignation d'employé à un rendez-vous. Erreur: ", error)
            toast.error(error?.response?.data?.error || "Erreur lors de l'annulation de l'assignation  d'employé à un rendez-vous.");
        }
        set({ cancelAssignLoading: false });
    },

    // Bloquer un utilisateur
    blockUser: async (userId) => {
        set({ actionLoading: true });
        try {
            const response = await axiosToken.put(`/user/lock/${userId}`);

            // Mettre à jour l'état local
            set(state => ({
                members: state.members.map(member =>
                    member.id === userId
                        ? { ...member, isActive: false, isLocked: true }
                        : member
                ),
                actionLoading: false
            }));

            toast.success("Utilisateur bloqué avec succès");
            return response.data;
        } catch (error) {
            console.error("Erreur blockUser :", error);
            toast.error(error?.response?.data?.error || "Erreur lors du blocage de l'utilisateur.");
            set({ actionLoading: false });
            throw error;
        }
    },

    // Débloquer un utilisateur
    unblockUser: async (userId) => {
        set({ actionLoading: true });
        try {
            const response = await axiosToken.put(`/user/unlock/${userId}`);

            // Mettre à jour l'état local
            set(state => ({
                members: state.members.map(member =>
                    member.id === userId
                        ? { ...member, isActive: true, isLocked: false }
                        : member
                ),
                actionLoading: false
            }));

            toast.success("Utilisateur débloqué avec succès");
            return response.data;
        } catch (error) {
            console.error("Erreur unblockUser :", error);
            toast.error(error?.response?.data?.error || "Erreur lors du déblocage de l'utilisateur.");
            set({ actionLoading: false });
            throw error;
        }
    },

    // Changer le rôle d'un utilisateur
    updateUserRole: async (userId, newRole) => {
        set({ actionLoading: true });
        try {
            const response = await axiosToken.put(`/user/update-role/${userId}`, {
                role: newRole
            });

            // Mettre à jour l'état local
            set(state => ({
                members: state.members.map(member =>
                    member.id === userId
                        ? { ...member, role: newRole }
                        : member
                ),
                actionLoading: false
            }));

            toast.success("Rôle mis à jour avec succès");
            return response.data;
        } catch (error) {
            console.error("Erreur updateUserRole :", error);
            toast.error(error?.response?.data?.error || "Erreur lors de la modification du rôle.");
            set({ actionLoading: false });
            throw error;
        }
    },

}));